/* 
PRIMARY COLORS
- Orange > CMYK 0, 57, 78, 0 : #FF6C36
- Purple > CMYK 58, 67, 0, 6 : #6450f0
*/
import React from "react";

import PrivateRoute from './Auth/PrivateRoute'

// Import component pages 
import { Components, Incidents, Login, PageSettings, Registration, Statuspages , NewIncident, EditIncident, 
    StatuspageDetails, Settings, Team, Profile, NewStatusPage, Logout, JoinTeam, EmailValidation, ForgotPassword, ResetPassword, Billing , StatuspageBillingDetails } from "./Pages";
 
import './App.css'
import { Navigate, Route, Routes } from "react-router-dom";
import { Sidebar } from "./Components/Sidebar/Sidebar";
import { useSelector } from "react-redux";
import { InitCreatePage } from "./Pages/Initilisation/Create";
import { MagicLoginVerification } from "./Pages/MagicLogin/magicLoginVerification";
import { isLoggedIn } from "./Auth/SecurityController";
// import { NewIncident } from "./Pages/Incidents";

function App() {

    // Grab the data from redux 
	const { user , org } = useSelector((state) => state.auth);
    const { general } = useSelector((state) => state.ui) 
   


	return(
		<div className={`app-wrapper ${user && user?.token !=='' ? 'logged' : ''} ${user && general?.show_sidebar === true ? 'sidebar_opened' : ''}`} >
			{ user && general?.show_sidebar === true && <Sidebar />}
			<Routes>
				<Route path="/login/*" element={<Login />} />
				<Route path="/registration" element={<Registration />} />
				<Route path="/forgot-password" element={<ForgotPassword />} />
				<Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/join-team/:inviteId" element={<JoinTeam />} />
                <Route path="/email-validation/:confirmation_token" element={<EmailValidation />} />
                <Route path="/magic-link/:confirmation_token" element={<MagicLoginVerification />} />
                <Route path="/create" element={!user || !isLoggedIn(user) ? <InitCreatePage /> : <Navigate replace  to="/pages/new" />} />
				<Route element={<PrivateRoute />} >
				    <Route path="/logout" element={<Logout />} />
					<Route path="/" element={<Navigate replace  to="/pages" />} />
					<Route path="/pages" element={<Statuspages />} />
					<Route path="/pages/:page_id" element={<StatuspageDetails />} />
					<Route path="/pages/new" element={<NewStatusPage />} />
					{/* STATUSPAGES / COMPONENTS MANAGEMENT */}
					<Route path="/pages/:page_id/components/*" element={<Components />} />
					{/* <Route path="/pages/:page_id/components/new" element={<NewComponent />} /> */}
					{/* <Route path="/pages/:page_id/components/:component_id/edit" element={<EditComponent />} /> */}
					{/* STATUSPAGES / INCIDENTS MANAGEMENT */}
					<Route path="/pages/:page_id/incidents" element={<Incidents />} />
					<Route path="/pages/:page_id/incidents/new" element={<NewIncident />} />
					<Route path="/pages/:page_id/incidents/:incident_id/edit" element={<EditIncident />} />
					{/* STATUSPAGES / SUBSCRIBERS MANAGEMENT */}
					{/* <Route path="/pages/:page_id/subscribers" element={<Subscribers />} /> */}
					{/* <Route path="/pages/:page_id/subscribers/new" element={<NewSubscriber />} /> */}
					{/* <Route path="/pages/:page_id/subscribers/:subscriber_id/edit" element={<EditSubscriber />} /> */}
					{/* STATUSPAGES / SETTINGS */}
					<Route path="/pages/:page_id/settings/*" element={<PageSettings />} />
					{/* ORGANIZATIONS ? AUTOMATIONS ( UPTIME PROVIDERS ) */}
					{/* <Route path="/o/:organization_id/automations" element={<Automations />} /> */}
					{/* STATUSPAGES / BILLING */}
					<Route path="/pages/:page_id/billing" element={<StatuspageBillingDetails />} />
					{/* ORGANIZATION / TEAM */}
					<Route path="/team/*" element={<Team />} />
					{/* ORGANIZATION / SETTINGS */}
					<Route path="/settings" element={<Settings />} />
					{/* ORGANIZATION / SETTINGS */}
					<Route path="/profile" element={<Profile />} />
					{/* ORGANIZATION / SETTINGS */}
					<Route path="/billing" element={<Billing />} />

					

					
				</Route>
			</Routes>
		</div>
	)

}

export default App;